"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fflineEmpDelete = fflineEmpDelete;
exports.fflineEmpGetRoleList = fflineEmpGetRoleList;
exports.fflineEmpGetSave = fflineEmpGetSave;
exports.fflineEmpGetreSetImport = fflineEmpGetreSetImport;
exports.fflineEmpGetreSetImportUser = fflineEmpGetreSetImportUser;
exports.fflineEmpGetreSetPassword = fflineEmpGetreSetPassword;
exports.fflineEmpGetreSetStatus = fflineEmpGetreSetStatus;
exports.fflineEmpGetreSetUpdate = fflineEmpGetreSetUpdate;
exports.fflineEmployee = fflineEmployee;
exports.offlineStoreDelete = offlineStoreDelete;
exports.offlineStoreList = offlineStoreList;
exports.offlineUserStoreList = offlineUserStoreList;
exports.offlineUserStoreSave = offlineUserStoreSave;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 店铺列表
 */
function offlineStoreList(params) {
  // return request({
  //     url: '/admin/offlineStore/list',
  //     method: 'GET',
  //     params,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/offline-store/list',
    method: 'GET',
    params: params
  });
}

/**
 * 店铺选择列表
 */
function offlineUserStoreList(params) {
  // return request({
  //     url: '/admin/system/admin/offlineUser/autoList',
  //     method: 'GET',
  //     params,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/system/admin/offlineUser/autoList',
    method: 'GET',
    params: params
  });
}

/**
 * 添加店铺
 */
function offlineUserStoreSave(data) {
  // return request({
  //     url: '/admin/offlineStore/saveOrUpdate',
  //     method: 'post',
  //     data,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/offline-store/save-or-update',
    method: 'post',
    data: data
  });
}

/**
 * 删除店铺
 */
function offlineStoreDelete(params) {
  // return request({
  //     url: '/admin/offlineStore/delete',
  //     method: 'GET',
  //     params,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/offline-store/delete',
    method: 'GET',
    params: params
  });
}

// 员工列表
/**
 * 员工列表
 */
function fflineEmployee(params) {
  // return request({
  //     url: '/admin/offlineEmployee/list',
  //     method: 'GET',
  //     params,
  // });

  return (0, _requestMapi.default)({
    url: '/mapi/user/offline-employee/list',
    method: 'GET',
    params: params
  });
}

/**
 * 删除员工
 */
function fflineEmpDelete(params) {
  // return request({
  //     url: '/admin/offlineEmployee/delete',
  //     method: 'GET',
  //     params,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/offline-employee/delete',
    method: 'GET',
    params: params
  });
}

/**
 * 获取角色列表
 */
function fflineEmpGetRoleList(params) {
  // return request({
  //     url: '/admin/offlineEmployee/getRoleList',
  //     method: 'GET',
  //     params,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/offline-employee/role-list',
    method: 'GET',
    params: params
  });
}

/**
 * 添加员工
 */
function fflineEmpGetSave(data) {
  // return request({
  //     url: '/admin/offlineEmployee/save',
  //     method: 'post',
  //     data,
  // });

  return (0, _requestMapi.default)({
    url: '/mapi/user/offline-employee/save',
    method: 'post',
    data: data
  });
}

/**
 * 重置员工密码
 */
function fflineEmpGetreSetPassword(params) {
  // return request({
  //     url: '/admin/offlineEmployee/resetPassword',
  //     method: 'GET',
  //     params,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/offline-employee/reset-password',
    method: 'GET',
    params: params
  });
}

/**
 * 状态修改
 */
function fflineEmpGetreSetStatus(params) {
  // return request({
  //     url: '/admin/offlineEmployee/setStatus',
  //     method: 'GET',
  //     params,
  // });

  return (0, _requestMapi.default)({
    url: '/mapi/user/offline-employee/update-status',
    method: 'GET',
    params: params
  });
}

/**
 * 编辑员工
 */
function fflineEmpGetreSetUpdate(data) {
  // return request({
  //     url: '/admin/offlineEmployee/update',
  //     method: 'POST',
  //     data,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/user/offline-employee/update',
    method: 'POST',
    data: data
  });
}

/**
 * 导入店铺
 */
function fflineEmpGetreSetImport(formData) {
  return (0, _requestMapi.default)({
    //url: `/admin/offlineStore/import`,
    url: "/mapi/user/offline-store/import",
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 导入员工
 */
function fflineEmpGetreSetImportUser(formData) {
  return (0, _requestMapi.default)({
    //url: `/admin/offlineEmployee/import`,
    url: "/mapi/user/offline-employee/import",
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}